export { FadeIn } from './styles';
//# sourceMappingURL=index.js.map